import React, { Component } from "react";
import { connect } from "react-redux";
import { bulkAddEventBidders } from "../../../actions/event/EventBidderActions";
import { fetchBuyers } from "../../../actions/masters/userActions";
import { fetchEvents } from "../../../actions/event/EventActions";
import { toast } from "react-toastify";

class BulkMapBidders extends Component {
  state = {
    selectedBuyers: [],
    selectedAuctions: [],
    searchBuyerText: "",
    searchAuctionText: "",
  };

  componentDidMount() {
    this.props.fetchBuyers();
    this.props.fetchEvents();
  }

  handleBuyerSelection = (buyerId) => {
    this.setState((prevState) => {
      const selectedBuyers = [...prevState.selectedBuyers];
      const index = selectedBuyers.indexOf(buyerId);
      if (index !== -1) {
        selectedBuyers.splice(index, 1);
      } else {
        selectedBuyers.push(buyerId);
      }
      return { selectedBuyers };
    });
  };

  handleAuctionSelection = (auctionId) => {
    this.setState((prevState) => {
      const selectedAuctions = [...prevState.selectedAuctions];
      const index = selectedAuctions.indexOf(auctionId);
      if (index !== -1) {
        selectedAuctions.splice(index, 1);
      } else {
        selectedAuctions.push(auctionId);
      }
      return { selectedAuctions };
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { selectedBuyers, selectedAuctions } = this.state;

    if (selectedBuyers.length === 0 || selectedAuctions.length === 0) {
      toast.error("Please select at least one buyer and one auction");
      return;
    }

    // Ensure we're sending integer IDs
    const data = {
      auctionIds: selectedAuctions.map(id => parseInt(id)),
      buyerIds: selectedBuyers.map(id => parseInt(id)),
    };

    console.log("Submitting bulk mapping data:", data);

    await this.props.bulkAddEventBidders(data);
    
    // Clear selections after successful submission
    this.setState({
      selectedBuyers: [],
      selectedAuctions: [],
    });
  };

  renderBuyersList = () => {
    const buyers = Object.values(this.props.buyers || {});
    const filteredBuyers = buyers.filter((buyer) =>
      buyer.user_name?.toLowerCase().includes(this.state.searchBuyerText.toLowerCase()) ||
      buyer.email_id?.toLowerCase().includes(this.state.searchBuyerText.toLowerCase())
    );

    return (
      <div className="listContainer">
        <h5>Select Buyers</h5>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search by name or email"
          value={this.state.searchBuyerText}
          onChange={(e) => this.setState({ searchBuyerText: e.target.value })}
        />
        <div className="scrollableList">
          {filteredBuyers.map((buyer) => (
            <div key={buyer.id} className="custom-control custom-checkbox mb-2">
              <input
                type="checkbox"
                className="custom-control-input"
                id={`buyer-${buyer.id}`}
                checked={this.state.selectedBuyers.includes(buyer.id)}
                onChange={() => this.handleBuyerSelection(buyer.id)}
              />
              <label className="custom-control-label" htmlFor={`buyer-${buyer.id}`}>
                {buyer.user_name} - {buyer.email_id}
              </label>
            </div>
          ))}
        </div>
        <div className="mt-2">
          <strong>Selected: {this.state.selectedBuyers.length} buyer(s)</strong>
        </div>
      </div>
    );
  };

  renderAuctionsList = () => {
    const events = Object.values(this.props.events || {});
    const filteredEvents = events.filter((event) => {
      const isLiveOrFuture = event.status === "LIVE" || event.status === "FUTURE";
      const matchesSearch = 
        event.eventId?.toLowerCase().includes(this.state.searchAuctionText.toLowerCase()) ||
        event.claimNo?.toLowerCase().includes(this.state.searchAuctionText.toLowerCase());
      
      return isLiveOrFuture && (this.state.searchAuctionText === "" || matchesSearch);
    });

    return (
      <div className="listContainer">
        <h5>Select Auctions (Live & Future)</h5>
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Search by Event ID or Claim No"
          value={this.state.searchAuctionText}
          onChange={(e) => this.setState({ searchAuctionText: e.target.value })}
        />
        <div className="scrollableList">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event) => (
              <div key={event.id} className="custom-control custom-checkbox mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`auction-${event.id}`}
                  checked={this.state.selectedAuctions.includes(event.id)}
                  onChange={() => this.handleAuctionSelection(event.id)}
                />
                <label className="custom-control-label" htmlFor={`auction-${event.id}`}>
                  {event.eventId} - {event.claimNo} [{event.status}]
                </label>
              </div>
            ))
          ) : (
            <p className="text-muted text-center mt-3">No Live or Future auctions available</p>
          )}
        </div>
        <div className="mt-2">
          <strong>Selected: {this.state.selectedAuctions.length} auction(s)</strong>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Bulk Map Bidders to Auctions</h3>
          </div>
        </div>

        <div className="mainBodyCard pt-30">
          <div className="row">
            <div className="col-md-6">{this.renderBuyersList()}</div>
            <div className="col-md-6">{this.renderAuctionsList()}</div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12 text-center">
              <button
                className="btn btn-primary btn-lg"
                onClick={this.handleSubmit}
                disabled={
                  this.state.selectedBuyers.length === 0 ||
                  this.state.selectedAuctions.length === 0
                }
              >
                Map Selected Bidders to Auctions
              </button>
            </div>
          </div>
        </div>

        <style jsx>{`
          .listContainer {
            padding: 20px;
            background: #f8f9fa;
            border-radius: 8px;
            height: 500px;
            display: flex;
            flex-direction: column;
          }
          .scrollableList {
            flex: 1;
            overflow-y: auto;
            border: 1px solid #ddd;
            padding: 10px;
            background: white;
            border-radius: 4px;
          }
        `}</style>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    buyers: state.userMaster,
    events: state.event,
  };
};

export default connect(mapStateToProps, {
  bulkAddEventBidders,
  fetchBuyers,
  fetchEvents,
})(BulkMapBidders);